/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import { useLingui } from '@lingui/react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import * as React from 'react'

import { ExternalLink } from '@/components/fragments/external-link'
import { MENU_LINKS } from '@/constants/menu-links'
import { MobileMenu } from '@/components/sections/mobile-menu'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle
} from '@/components/ui/navigation-menu'
import { getCompanyProfileRoute, Routes } from '@/constants/routes'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import Logo from 'public/landing/logos/group.png'
import { Switcher } from './switcher-language'
export function Navbar(): React.JSX.Element {
  const pathname = usePathname()
  const { i18n } = useLingui()
  const companyProfileLink = getCompanyProfileRoute(i18n.locale)
  return (
    <section className='sticky inset-x-0 top-0 z-50 py-3 bg-background'>
      <div className='container'>
        <nav className='hidden justify-between min-[1220px]:flex'>
          <div className='flex items-center w-full justify-between gap-x-3 2xl:gap-x-9'>
            <Link href={Routes.Root} className='flex items-center'>
              <Image
                src={Logo}
                width={377}
                height={84}
                className='w-auto max-h-9'
                alt='Logo Pione'
              />
            </Link>
            <NavigationMenu
              style={
                {
                  ['--radius']: '1rem'
                } as React.CSSProperties
              }
            >
              <NavigationMenuList>
                {MENU_LINKS.map((item, index) => {
                  if (item.items) {
                    return (
                      <NavigationMenuItem key={index}>
                        <NavigationMenuTrigger
                          data-active={
                            item.items.some((subItem) => pathname.startsWith(subItem?.href || '')) ?
                              ''
                            : undefined
                          }
                          className='relative data-[active]:bg-accent'
                        >
                          {i18n._(item.title)}
                        </NavigationMenuTrigger>
                        <NavigationMenuContent>
                          <div className='w-screen '>
                            <ul
                              className={cn(
                                'p-4 list-none container pl-[15dvw] 2xl:pl-[215px] gap-2 max-h-[70vh] overflow-y-auto',
                                index !== 3 && index !== 2 ? 'grid grid-cols-3' : 'grid grid-cols-4'
                              )}
                            >
                              {item.items.map((subItem: any, subIndex) => {
                                const href =
                                  subItem.isCompanyProfile ? companyProfileLink : (
                                    subItem.href || '#'
                                  )

                                return (
                                  <li key={subIndex}>
                                    <NavigationMenuLink asChild>
                                      <Link
                                        href={href || '#'}
                                        target={subItem.external ? '_blank' : undefined}
                                        rel={subItem.external ? 'noopener noreferrer' : undefined}
                                        className='relative flex flex-row items-center gap-4 p-3 leading-none rounded-sm select-none group w-fit'
                                      >
                                        {i18n._(subItem.title)}
                                        {subItem.external && (
                                          <ExternalLink className='inline ml-1 -mt-2 text-muted-foreground' />
                                        )}
                                        <span className='absolute bottom-2 left-3 h-px bg-gradient-to-r from-orange-600 to-orange-400 w-0 group-hover:w-[90%] transition-all duration-300 ease-in-out'></span>
                                      </Link>
                                    </NavigationMenuLink>
                                  </li>
                                )
                              })}
                            </ul>
                          </div>
                        </NavigationMenuContent>
                      </NavigationMenuItem>
                    )
                  }

                  return (
                    <NavigationMenuItem key={index}>
                      <NavigationMenuLink
                        asChild
                        active={pathname.startsWith(item.href)}
                        className={cn(
                          navigationMenuTriggerStyle(),
                          'rounded-sm font-medium data-[active]:text-accent-orange'
                        )}
                      >
                        <Link
                          href={item.href || '#'}
                          target={item.external ? '_blank' : undefined}
                          rel={item.external ? 'noopener noreferrer' : undefined}
                        >
                          {i18n._(item.title)}
                        </Link>
                      </NavigationMenuLink>
                    </NavigationMenuItem>
                  )
                })}
              </NavigationMenuList>
            </NavigationMenu>
            <div className='flex items-center gap-2'>
              <Switcher />
              {/* <ThemeToggle className='border-none shadow-none rounded-xl' /> */}
            </div>
          </div>
        </nav>
        <MobileMenu className='min-[1220px]:hidden' />
      </div>
      <div className='absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-black via-orange-400/70 to-black'></div>
    </section>
  )
}
